import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table.tsx';
import { Button } from '../ui/button.tsx';
import type { RefreshableMetric } from './registry.ts';

interface Props {
  metrics: RefreshableMetric[];
  onRefresh: (metric: RefreshableMetric) => void;
  isPendingFor: (id: string) => boolean;
}

function buttonLabel(metric: RefreshableMetric): string {
  switch (metric.params.kind) {
    case 'none':
      return 'Refresh';
    case 'backfill':
      return 'Backfill…';
    case 'month':
      return 'Recompute…';
    case 'force':
      return 'Refresh…';
  }
}

export function RefreshTable({ metrics, onRefresh, isPendingFor }: Props) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Last computed</TableHead>
          <TableHead>Schedule</TableHead>
          <TableHead className='w-32 text-right'>Action</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {metrics.map((m) => (
          <TableRow key={m.id}>
            <TableCell className='font-medium'>{m.displayName}</TableCell>
            <TableCell className='text-muted-foreground'>
              {m.lastComputedAt ?? '—'}
            </TableCell>
            <TableCell className='text-muted-foreground'>
              {m.schedule ?? '—'}
            </TableCell>
            <TableCell className='text-right'>
              <Button
                size='sm'
                onClick={() => onRefresh(m)}
                disabled={isPendingFor(m.id)}
              >
                {buttonLabel(m)}
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
